<template>
  <div>
    <div id="mobile-topbar" class="d-print-none">
      <span>Logged in as {{ user.userId }}</span>
      <a
        href="javascript:document.getElementById('logoutForm').submit()"
        class="log-off-link"
        >Log off</a
      >
      <div
        class="toggle-menu-icon"
        @click="changeMobileNavbarState(!mobileNavbar.expanded)"
      >
        <font-awesome-icon icon="bars" class="toggle-menu-item" />
      </div>
    </div>
    <div
      :class="{ 'nav-modal': 'true', show: mobileNavbar.expanded }"
      @click="changeMobileNavbarState(false)"
    ></div>
    <div
      id="menu"
      :class="{
        'd-print-none': 'true',
        'ui-resizable': 'true',
        show: mobileNavbar.expanded,
      }"
    >
      <div class="slimScrollDiv">
        <div class="slim-scroll">
          <!-- Sidebar Profile -->
          <div class="profile" v-if="user.userId !== undefined">
            <a
              class="img"
              :href="
                'https://webapp4.asu.edu/directory/photo?user=' + user.userId
              "
            >
              <img
                :src="
                  'https://webapp4.asu.edu/directory/photo?user=' + user.userId
                "
              />
            </a>
            <span>
              <strong>Welcome</strong>
              <a href="/">{{ user.firstName }}</a>
            </span>
          </div>
          <!-- // Sidebar Profile END -->
          <menu-tree :items="navItems"></menu-tree>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { routes } from "../router/routes.js";
import MenuTree from "@/components/menu/menu-tree";
import store from "../store";
import { mapActions, mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import roleChecks from "../misc/role-checks";

export default {
  mixins: [roleChecks],
  data() {
    return {
      routes,
      showMobileNavbar: false,
      navItems: [],
    };
  },

  components: {
    "menu-tree": MenuTree,
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      mobileNavbar: (state) => state.navbar.mobileNavbar,
    }),

    accessibleRoutes: function () {
      var accessible = [];
      _.forEach(this.routes, function (route) {
        // Only display a route if the user has access to it
        if (_.has(route.meta, "roles")) {
          var authorizedRoles = route.meta.roles;
          if (store.getters.isAuthorized(authorizedRoles)) {
            accessible.push(route);
          }
        } else {
          accessible.push(route);
        }
      });
      return accessible;
    },
  },

  watch: {
    accessibleRoutes: function () {
      // pass in null to tell it to start removing items from tree with depth 0, not a sublist of children
      this.setNavItems();
    },
  },

  methods: {
    setNavItems: function () {
      this.navItems = [];

      // set the nav menu depending on which roles user has
      // TODO: set this more dynamically based on user roles from the store
      this.navItems.push({ text: "Home", icon: "home", route: "/" });

      this.navItems.push({
        text: "My Dashboard",
        icon: "user",
        // route: "/dashboard",
        route: { name: "dashboard" },
      });

      if (this.isEmployeesManager || this.isEmployeesViewer) {
        this.navItems.push({
          text: "All Faculty",
          icon: "user",
          route: { name: "facultyAll" },
        });
      }

      // if (this.isExpertsAdmin || this.isExpertsEditor || this.isExpertsViewer)
      if (this.isCPViewer || this.isCPManager) {
        var communityPartnersBranch = {
          text: "Community Partnerships",
          icon: "hands-helping",
          children: [],
        };
        communityPartnersBranch.children.push({
          text: "Community Partnership List",
          route: { name: "communityPartners" },
        });

        if (this.isCPManager) {
          communityPartnersBranch.children.push({
            text: "Add Community Partner",
            route: { name: "communityPartnerAdd" },
          });
        }

        this.navItems.push(communityPartnersBranch);
      }

      if (this.isProjectsManager || this.isProjectsViewer) {
        var projectsBranch = {
          text: "Other Projects",
          icon: "pencil-alt",
          children: [],
        };
        projectsBranch.children.push({
          text: "Project List",
          route: { name: "projects" },
        });

        if (this.isProjectsManager) {
          projectsBranch.children.push({
            text: "Add Project",
            route: { name: "projectAdd" },
          });
        }

        this.navItems.push(projectsBranch);
      }

      if (this.isAwardsManager || this.isAwardsViewer) {
        this.navItems.push({
          text: "Sponsored Awards",
          icon: "file-invoice-dollar",
          route: { name: "awards" },
        });
      }

      if (this.isProposalsViewer || this.isProposalsManager) {
        this.navItems.push({
          text: "Proposals",
          icon: "file-invoice-dollar",
          route: { name: "proposals" },
        });
      }

      //   this.navItems.push({
      //     text: "Research Collaborators",
      //     icon: "users",
      //     route: { name: "researchCollaborators" }
      //   });

      this.navItems.push({
        text: "Expertise Areas",
        icon: "lightbulb",
        route: { name: "expertiseAreas" },
      });

      this.navItems.push({
        text: "Request Help",
        icon: "question-circle",
        link: "https://links.asu.edu/chsapplicationintake",
      });
    },

    ...mapActions(["expandNavbar", "contractNavbar"]),

    changeMobileNavbarState(expand) {
      if (expand) {
        this.$store.dispatch("expandNavbar");
      } else {
        this.$store.dispatch("contractNavbar");
      }
    },
  },
};
</script>

<style>
#mobile-topbar {
  display: none;
}

.nav-modal {
  display: none;
}

#menu {
  width: 235px;
  position: static;
  float: left;
  left: 0;
  top: 0;
  overflow: hidden;
  margin-bottom: -99999px;
  padding-bottom: 99999px;
  background: #44413e;
  color: white;
}

#menu .profile span {
  text-align: left;
  display: block;
  padding-top: 3px;
  width: 130px;
  float: right;
}

#menu .profile span strong {
  display: block;
  color: white;
  font-size: 14px;
  font-weight: normal;
}

#menu .profile span a {
  color: #e04545;
  font-size: 14px;
  padding-right: 25px;
  text-decoration: none;
}

#menu .profile span a:hover {
  text-decoration: underline;
}

.profile {
  padding: 10px;
  border-bottom: 1px solid #575452;
  overflow: auto;
}

.img {
  border: 2px solid #696765;
  width: 40px;
  border-radius: 5px;
  float: left;
}

.img:hover {
  border-color: #9c9a98;
}

img {
  max-width: 100%;
  height: auto;
  border-radius: 5px;
}

.slimScrollDiv {
  position: relative;
  overflow: hidden;
  width: auto;
}

.slim-scroll > ul {
  list-style: none;
  float: left;
  margin: 0;
  padding: 0;
  display: block;
  width: 100%;
  background: #52504d;
  border-top: 1px solid #64625f;
}

.slim-scroll > ul > li {
  display: block;
  height: 39px;
  max-height: 39px;
  line-height: 39px;
  border-bottom: 1px solid #64625f;
  position: relative;
  overflow: hidden;
  padding: 0;
  margin: 0;
  transition: max-height 2s;
}

.slim-scroll > ul > li.expanded {
  height: auto;
  max-height: 900px;
  background: #42403e;
  transition: max-height 2s;
}

.slim-scroll > ul ul {
  list-style: none;
  padding: 0;
}

.slim-scroll > ul ul li a {
  font-weight: 400;
}

.slim-scroll > ul ul li {
  height: auto;
}

.slim-scroll > ul > li a,
.submenu-name {
  display: block;
  width: auto;
  margin: 0;
  color: white;
  height: 39px;
  font-size: 13px;
  font-weight: 600;
  padding-left: 45px;
  text-decoration: none;
}

.slim-scroll > ul > li a:hover,
.submenu-name:hover {
  background: #363432;
  cursor: pointer;
}

.expanded .submenu-name {
  background: #42403e;
}

.children-count {
  display: inline-block;
  background: #363432;
  color: white;
  font-weight: 600;
  font-size: 10px;
  padding: 1px 8px;
  position: absolute;
  border-radius: 3px;
  top: 10px;
  right: 15px;
  line-height: normal;
}

.nav-icon {
  left: 15px;
  top: 10px;
  position: absolute;
  font-size: 17px;
}

.slim-scroll {
  overflow: hidden;
  width: auto;
}

.log-off-link {
  color: #e04545;
  margin-left: 5px;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  #mobile-topbar {
    display: block;
    width: 100%;
    background: #44413e;
    position: absolute;
    height: 30px;
    top: 0;
    color: white;
    padding: 3px;
  }

  .toggle-menu-icon {
    float: right;
    margin-right: 5px;
  }

  #menu {
    left: -235px;
    position: absolute;
    transition: 1s;
    z-index: 100;
  }

  #menu.show {
    left: 0;
    transition: 1s;
  }

  .nav-modal.show {
    display: block;
    width: 100vw;
    height: 100vh;
    z-index: 4;
    background-color: rgba(0, 0, 0, 0.4);
    transition: 1s;
  }
}
</style>
